export const getIsOfflineMode = (state) => state.globalReducer.isOfflineMode;
